// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__1Fn0L","tab":"Tabs_tab__1rcio","isActiveTab":"Tabs_isActiveTab__1X2zN"};